import { isNotFound, isRedirect } from "@tanstack/react-router";
import { requestUnavailable } from "@softmax/observatory-client/transport";

export function isRouteAccessDenied(error: unknown): boolean {
  return (
    isNotFound(error) ||
    isRedirect(error) ||
    (error instanceof Error && requestUnavailable(error))
  );
}
